<template>
  <span>
    <v-menu offset-y left v-model="isMenuOpen" min-width="400px" max-height="600px">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" @click="getCollection()">
          <v-badge :color="requests.length > 0 ? 'red' : ''" overlap :content="totalCount">
            <v-icon>mdi-gavel</v-icon>
          </v-badge>
        </v-btn>
      </template>

      <v-skeleton-loader
        v-if="request.loading"
        ref="skeleton"
        type="list-item-avatar-three-line@1"
        class="mx-auto"
      />

      <v-list v-if="!request.loading && isMenuOpen" dense subheader>
        <v-subheader>{{ $lang('main.navbar.unconfirmed_legal_compliance_requests.title') }}</v-subheader>
        <v-list-item v-if="!requests.length">
          {{$lang('main.crud.no_records')}}
        </v-list-item>
        <v-list-item
          v-for="(request, r) in requests"
          :key="r"
          two-line
          @click="navigateToComplianceRequests(request)"
        >
          <v-list-item-icon>
            <v-badge color="accent" overlap :content="request.guests.length ? request.guests.length : '0'">
              <v-icon large>mdi-account</v-icon>
            </v-badge>
          </v-list-item-icon>
          <v-list-item-content v-if="request.guests.length">
            <v-list-item-title>{{ request.guests[0].first_name }} {{ request.guests[0].first_surname }}</v-list-item-title>
            <!-- <v-list-item-subtitle>
              <v-icon small>mdi-office-building</v-icon>
              {{ reservation.property.name }}
            </v-list-item-subtitle> -->
            <v-list-item-subtitle>
              {{ $toDateFormat(request.start_date) }}
              <v-icon small>mdi-arrow-right</v-icon>
              {{ $toDateFormat(request.end_date) }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-content v-else>
            <v-list-item-title>
              {{ $toDateFormat(request.start_date) }}
              <v-icon small>mdi-arrow-right</v-icon>
              {{ $toDateFormat(request.end_date) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog v-model="isOpenReservationEditing" persistent fullscreen hide-overlay>
      <ReservationEditingForm
        v-if="isOpenReservationEditing"
        :item-id="activeReservationId"
        :open-tab="tabToOpen"
        @cancel="closeReservationEditing"
      />
    </v-dialog>
  </span>
</template>

<script>
  import { mapState } from "vuex";
  import MixpanelEvents from "@/constants/events";

  import {
    GET_LEGAL_COMPLIANCE_COLLECTION,
    LISTEN_LEGAL_COMPLIANCE_UNCONFIRMED,
  } from "@/store/legal-compliance-requests/actions";

  const ReservationEditingForm = () => import("@/pages/reservations/EditingForm");

  export default {
    name: "UnconfirmedLegalComplianceRequests",
    components: {
      ReservationEditingForm,
    },
    data() {
      return {
        isMenuOpen: false,
        isOpenReservationEditing: false,
        activeReservationId: null,
        tabToOpen: null,
      };
    },
    mounted() {
      this.getCollection();
      //this.listenCollection();
    },
    methods: {
      getCollection() {
        if (this.$can('INTERNAL_SUPPORT')) {
          return;
        }

        this.$store.dispatch(GET_LEGAL_COMPLIANCE_COLLECTION, {
          withUnconfirmed: true,
        });

        this.$monitorService.track(MixpanelEvents.CHECKIN_BADGE_CLICKED);
      },
      listenCollection() {
        this.$store.dispatch(LISTEN_LEGAL_COMPLIANCE_UNCONFIRMED);
      },
      navigateToComplianceRequests(item) {        
        this.$monitorService.track(MixpanelEvents.CHECKIN_TO_CONFIRM_ITEM_CLICKED);

        if (item.reservation_id) {
          this.activeReservationId = item.reservation_id;
          this.isOpenReservationEditing = true;
          this.tabToOpen = 'tab-legal_compliance';
          return;
        }

        this.$router.push({
          name: 'legal-compliance-requests',
          query: {
            from: this.$moment().subtract(1, 'day').format('YYYY-MM-DD'),
            to: this.$moment().add(1, 'day').format('YYYY-MM-DD'),
          },
        });
      },
      closeReservationEditing() {
        this.isOpenReservationEditing = false;
        this.activeReservationId = null;
      }
    },
    computed: {
      ...mapState({
        request: state => state.legalComplianceRequests.getCollectionRequest
      }),
      requests() {
        return this.request.collection;
      },
      totalCount() {
        if (!this.request.collection) {
          return 0;
        }

        return this.request.collection.length;
      },
    }
  };
</script>
